<template>
  <DataList
    title="Менеджери"
    resource="managers"
    :columns="columns"
    :get-items-fn="getManagers"
    :search-label="'Пошук за назвою менеджера'"
  />
</template>

<script>
import * as managersApi from "../../../backend/managersApi.js";

export default {
  data: () => ({
    columns: [
      { title: "id", name: "id" },
      { title: "Найменування", name: "title" },
      { title: "План продаж", name: "salesPlan" },
    ],
  }),
  methods: {
    getManagers(...args) {
      return managersApi.getManagers(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
